import { createFileRoute } from "@tanstack/react-router";
import Settings from "@/pages/Settings";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/settings")({
  head: () => ({
    meta: [
      { title: "Settings | Statlign" },
      { name: "description", content: "Manage your Statlign account preferences, notifications and timezone." },
      { property: "og:title", content: "Settings | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Manage your Statlign account preferences, notifications and timezone." },
      { name: "twitter:title", content: "Settings | Statlign" },
      { name: "twitter:description", content: "Manage your Statlign account preferences, notifications and timezone." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <Settings />
    </MainLayout>
  ),
});
